export default '/static/frontend/ReachDigital/12gobiking/dist/assets/mastercard-8c287d77.svg'